import React from 'react'
import styled from 'styled-components'
import { rhythm, media } from '../utils/typography'
import { withTranslation } from 'react-i18next'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Section from '../components/section'
import Link from '../components/link'
import Image from '../components/image'
import Flag from '../components/flag'

export default styled(withTranslation()(({ className, t, pageContext }) => {
  const { member, image, html } = pageContext
  const name = [member.prefix, member.firstname, member.lastname, member.suffix].join(' ')
  return (
    <Layout className={className}>
      <SEO title={name}
        image={image ? image.childImageSharp.fixed.src : null} />

      <Section title={t('members.title')}>
        <header>
          <h1>
            <span className='name'>{name}</span>
            {member.country && member.party ?
              <span className='background'>
                <span className='flag'>
                  <Flag className='flag-svg' country={member.country} />
                </span>
                <span className='country'>{t(`countries.${member.country}`)}</span>
                {' / '}
                <span className='party'>{member.party}</span>
              </span>
            : null}
          </h1>
        </header>

        <section className='profile'>
          <span className='image'>
            {image ? <Image fixed={image.childImageSharp.fixed} /> : null}
          </span>

          <section>
            <h2>{member.position}</h2>
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </section>
        </section>

        <footer>
          <Link to='/team'>&laquo;&nbsp;{t('members.title')}</Link>
        </footer>
      </Section>
    </Layout>
  )
}))`
  .name, .background {
    display: inline-block;
  }
  .name {
    margin-right: ${rhythm(1/4)};
  }
  .background {
    font-size: 0.7em;
  }

  .flag {
    display: inline-block;
    margin: 0 ${rhythm(1/4)};
    height: 0.7em;
  }

  .flag-svg {
    height: 100%;
  }

  .image {
    display: block;
    text-align: center;
    margin: ${rhythm(1/4)};
    ${media.tablet} {
      display: inline;
      float: left;
      margin-right: ${rhythm(1)};
    }
  }

  footer {
    margin: ${rhythm(1/4)} 0 ${rhythm(1)};
  }
`
